import { Button, HeroSection } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'
import { createStoryblokMultilink } from '../../../../../__mocks__/storyblok/createStoryblokMultilink'

/**
 * Creates a mock Button for HeroSection
 */
function createHeroSectionButton(overrides: Partial<Button> = {}): Button {
  return {
    _uid: '0b50529a-2b9f-4368-b504-75a7bcf9d85b',
    link: createStoryblokMultilink({
      linktype: 'story',
    }),
    size: 'medium',
    label: 'Default',
    style: 'default',
    component: 'button',
    button_color: 'white',
    _editable:
      '<!--#storyblok#{"name": "button", "space": "228071", "uid": "0b50529a-2b9f-4368-b504-75a7bcf9d85b", "id": "300939517"}-->',
    ...overrides,
  }
}

/**
 * Creates a mock HeroSection
 * @param overrides - Partial fields to override defaults
 * @returns Complete HeroSection mock
 */
export function createHeroSection(
  overrides: Partial<HeroSection> = {}
): HeroSection {
  return {
    _uid: 'd0d0fc94-826a-4305-ab48-9224c5723a97',
    buttons: [
      createHeroSectionButton(),
      createHeroSectionButton({
        _uid: 'a1bce6ab-ac88-4216-943b-27a899666b04',
        link: createStoryblokMultilink({
          id: '2c86c59d-c031-426e-8c50-6d9b311c0204',
          linktype: 'story',
          cached_url: 'error-404',
        }),
        label: 'Semi transparent',
        style: 'semi',
        button_color: 'primary',
      }),
    ],
    headline: 'Next.js',
    component: 'hero-section',
    text_color: 'light',
    full_height: false,
    subheadline:
      'ein leistungsstarkes Framework für die Erstellung von schnellen, benutzerfreundlichen und SEO-optimierten statischen Webseiten und React-Webanwendungen',
    pattern_overlay: false,
    background_image: createStoryblokAsset({
      id: 8895725,
      alt: 'next js wallpaper',
      filename:
        'https://a.storyblok.com/f/228071/1920x1080/3b5be3d858/nextjs-wallpaper.png',
      src: 'https://a.storyblok.com/f/228071/1920x1080/3b5be3d858/nextjs-wallpaper.png',
      width: 1920,
      height: 1080,
      aspect_ratio: 1.78,
      content_type: 'image/png',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    background_video: createStoryblokAsset({
      id: 1,
      filename: '',
      src: '',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    vertical_alignment: 'center',
    horizontal_alignment: 'left',
    _editable:
      '<!--#storyblok#{"name": "hero-section", "space": "228071", "uid": "d0d0fc94-826a-4305-ab48-9224c5723a97", "id": "300939517"}-->',
    ...overrides,
  }
}
